/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelTariffRegionLtl.ts               *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/tariff-region-ltl";

export class AutogenModelTariffRegionLtl<RowType extends ModelRow> extends Endpoint<RowType, RowTariffRegionLtlFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowTariffRegionLtl extends ModelRow<RowTariffRegionLtlFields> {
	constructor(values?: Partial<RowTariffRegionLtlFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowTariffRegionLtlFields {
	add_timestamp: Date;
	add_userid: string;
	company_id: string;
	mod_timestamp: Date;
	mod_userid: string;
	parent_reg_name: string;
	parent_reg_uid: number;
	reg_type_code: string;
	reg_uid: number;
	region_gl_digits: string;
	region_name: string;
	region_nickname: string;
}

